/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import { Image as SemanticUIImage } from 'semantic-ui-react';
import BackgroundImage from 'gatsby-background-image';
import { isGatsbyImage } from '../../utils/gatsby';
import { ChildrenPropType } from '../../services/proptypes';

export function getImageKey(image) {
  if (typeof image === 'string') {
    return image;
  }
  if (image.fixed) {
    return image.fixed.src;
  }
  if (image.fluid) {
    return image.fluid.src;
  }
  return null;
}

class Image extends React.PureComponent {
  getImage() {
    const { imageQuery, src } = this.props;
    if (!!imageQuery && (!!imageQuery.fixed || !!imageQuery.fluid)) {
      return imageQuery;
    }
    if (typeof imageQuery === 'string' && !!imageQuery) {
      return imageQuery;
    }
    return src;
  }

  render() {
    const {
      as,
      src,
      background,
      imageQuery,
      altText,
      gatsbyImageProps,
      children,
      ...extraProps
    } = this.props;

    const image = this.getImage();

    if (!image) {
      return null;
    }

    if (isGatsbyImage(image)) {
      const allGatsbyImageProps = {
        ...extraProps,
        ...gatsbyImageProps,
        ...image,
        alt: altText || image.altText,
      };

      if (background) {
        return (
          <BackgroundImage Tag={as} {...allGatsbyImageProps}>
            {children}
          </BackgroundImage>
        );
      }
      return <Img {...allGatsbyImageProps} />;
    }

    // Handle simple URL image
    if (background) {
      return React.createElement(
        as,
        {
          ...extraProps,
          style: {
            backgroundImage: `url('${image}')`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            ...extraProps.style,
          }
        },
        children
      );
    }

    return <SemanticUIImage {...extraProps} src={image} alt={altText} />;
  }
}

export default Image;

Image.propTypes = {
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  background: PropTypes.bool,
  imageQuery: PropTypes.object,
  altText: PropTypes.string,
  gatsbyImageProps: PropTypes.object,
  children: ChildrenPropType,
};

Image.defaultProps = {
  as: 'div',
  src: '',
  background: false,
  imageQuery: null,
  altText: '',
  gatsbyImageProps: null,
  children: null,
};
